import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPrefillsByUserId,
  createPrefill,
  updatePrefillById,
} from "./redux/prefillThunk";
import {
  handleShowPopup,
  handleFormChange,
  setEditPrefill,
} from "./redux/prefillSlice";
import userStore from "../../zustand/userStore";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import Popup from "../../features/EventOrganiser/Popup";

const Show = () => {
  const dispatch = useDispatch();
  const userId = userStore.getState().user.id;

  const { data, loading, error, formData, showPopup, selectedPrefillId } =
    useSelector((state) => state.prefill);

  useEffect(() => {
    if (userId) {
      dispatch(fetchPrefillsByUserId(userId));
    }
  }, [dispatch, userId]);

  // const handleSave = () => {
  //   const payload = { ...formData, user_id: userId };
  //   dispatch(createPrefill(payload)).then(() => {
  //     // Clear form and close popup
  //     dispatch(handleFormChange({ name: "field_key", value: "" }));
  //     dispatch(handleFormChange({ name: "field_value", value: "" }));
  //     dispatch(handleShowPopup(false));
  //   });
  // };
  const handleSave = () => {
    const payload = { ...formData, user_id: userId };
    if (selectedPrefillId) {
      dispatch(updatePrefillById({ id: selectedPrefillId, ...formData })).then(
        () => {
          dispatch(handleShowPopup(false));
        }
      );
    } else {
      dispatch(createPrefill(payload)).then(() => {
        dispatch(handleShowPopup(false));
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "sno",
      },
      {
        Header: "Key",
        accessor: "field_key",
      },
      {
        Header: "Value",
        accessor: "field_value",
      },
      {
        Header: "Actions",
        accessor: "actions",
      },
    ],
    []
  );

  const processedData = useMemo(() => {
    return data.map((item, index) => ({
      ...item,
      sno: index + 1,
      actions: (
        <i
          className="fa fa-edit"
          style={{ cursor: "pointer", color: "green" }}
          onClick={() => dispatch(setEditPrefill(item))}
          title="Edit"
        ></i>
      ),
    }));
  }, [data]);

  return (
    <div className="main_container px-5">
      <button
        onClick={() => dispatch(handleShowPopup(true))}
        className="btn btn-primary"
      >
        Add Prefill
      </button>

      {loading && <p className="mt-3">Loading...</p>}
      {error && <p className="text-danger mt-3">Error: {error}</p>}

      {processedData.length > 0 ? (
        <div className="table-responsive mt-3">
          <AllFeatureDataTable columns={columns} data={processedData} />
        </div>
      ) : (
        <p className="mt-3">No Prefill Data Found</p>
      )}

      {showPopup && (
        <Popup
          title="Add Prefill"
          minHeight="250px"
          maxWidth="600px"
          onClose={() => dispatch(handleShowPopup(false))}
        >
          <div className="p-3">
            <div className=" mb-3">
              <label className="form-label">Prefill Key</label>
              <input
                type="text"
                name="field_key"
                value={formData.field_key}
                onChange={(e) =>
                  dispatch(
                    handleFormChange({
                      name: "field_key",
                      value: e.target.value,
                    })
                  )
                }
                className="form-control"
                placeholder="Enter prefill key"
              />
            </div>
            <div className=" mb-3">
              <label className="form-label">Prefill Value</label>
              <input
                type="text"
                name="field_value"
                value={formData.field_value}
                onChange={(e) =>
                  dispatch(
                    handleFormChange({
                      name: "field_value",
                      value: e.target.value,
                    })
                  )
                }
                className="form-control"
                placeholder="Enter prefill value"
              />
            </div>
            <div className="text-end">
              <button className="btn btn-success" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </Popup>
      )}
    </div>
  );
};

export default Show;
